/* eslint-disable no-unreachable */
/* eslint-disable import/prefer-default-export */
import { get } from 'lodash-es';

/**
 *
 * @param spreadsheetErrors
 * @param errorCode
 * @param lotNumberId
 * @param lotInvId
 * @param hasLotNumber
 * @param hasLotInvNumber
 * @returns {boolean}
 */
const isInCodeError = ({
  spreadsheetErrors,
  errorCode,
  lotNumberId,
  lotInvId,
  hasLotNumber,
  hasLotInvNumber
}) => {
  let isIndexed = false;

  if (hasLotNumber && hasLotInvNumber) {
    isIndexed = get(spreadsheetErrors, `[${errorCode}].lotNumbers`, new Set()).has(lotNumberId)
      && get(spreadsheetErrors, `[${errorCode}].invNumbers`, new Set()).has(lotInvId);
  } else if (hasLotNumber) {
    isIndexed = get(spreadsheetErrors, `[${errorCode}].lotNumbers`, new Set()).has(lotNumberId);
  } else if (hasLotInvNumber) {
    isIndexed = get(spreadsheetErrors, `[${errorCode}].invNumbers`, new Set()).has(lotInvId);
  }

  return isIndexed;
};

/**
 *
 * @func
 * @name validateErrorCode
 * @param {bool} isGoldPlatinum
 * @param {string | undefined} lotInvId
 * @param {string | undefined} lotNumberId
 * @param {object} rowInfo
 * @param {object} spreadsheetErrors
 * @param {number} errorCode
 * @returns {boolean}
 */
export const validateErrorCode = (
  isGoldPlatinum,
  lotInvId, lotNumberId,
  rowInfo,
  spreadsheetErrors,
  errorCode
) => {
  const hasLotInvNumber = !!lotInvId;
  const hasLotNumber = !!lotNumberId;

  /**
   * @returns {boolean}
   */
  const hasError = () => isInCodeError({
    spreadsheetErrors,
    errorCode,
    lotNumberId,
    lotInvId,
    hasLotNumber,
    hasLotInvNumber,
  });

  const hasTitle = get(rowInfo, 'original.lotTitle', false);
  const hasDescription = get(rowInfo, 'original.lotDescription', false);

  switch (errorCode) {
    case 101:
      return hasError() && !hasTitle;
    case '142-loEst':
      return hasError() && !hasLotInvNumber;
    case 164:
      return hasError() && !hasDescription;

    default:
      return hasError();
  }

  let errorPlatinumGold = false;

  /**
   * if isPlatinumGold equals true, then validate lot number exists, if lot number doesn't exist, then validate inv number
   * if isPlatinumGold equals false (silver), then validate required lot number
   */
  if (isGoldPlatinum) {
    errorPlatinumGold = !hasLotNumber && !hasLotInvNumber;
  } else {
    errorPlatinumGold = !hasLotNumber;
  }

  /**
   * 101 validation Missing title
   */

  const error101 = isInCodeError({
    spreadsheetErrors,
    errorCode: 101,
    lotNumberId,
    lotInvId,
    hasLotNumber,
    hasLotInvNumber,
  }) && !hasTitle;

  /**
   * 165 validation Character Limit
   */

  const error165 = isInCodeError({
    spreadsheetErrors,
    errorCode: 165,
    lotNumberId,
    lotInvId,
    hasLotNumber,
    hasLotInvNumber,
  });

  return {
    errorPlatinumGold,
    error101,
    error165,
  };
};
